import React from 'react';
import { cn, gaiaTheme, getCardClasses } from './baseUIConfig';

export const Card = ({
  children,
  className = '',
  onClick,
  hover = false,
  selected = false,
  padding = 'p-4',
}) => {
  return (
    <div
      className={cn(getCardClasses({ hover, selected, padding }), className)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '' }) => (
  <div className={cn(gaiaTheme.components.card.header, className)}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '' }) => (
  <h3 className={cn(gaiaTheme.components.card.title, className)}>
    {children}
  </h3>
);

export const CardContent = ({ children, className = '' }) => (
  <div className={cn(gaiaTheme.components.card.content, className)}>
    {children}
  </div>
);

export const CardFooter = ({ children, className = '' }) => (
  <div className={cn(gaiaTheme.components.card.footer, className)}>
    {children}
  </div>
);
